module.exports = __webpack_public_path__ + "img/undefined.ae0ed79c.png";